// extracted by mini-css-extract-plugin
export default {"root":"LocationList_root__bzIkq"};